var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermname(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 1.5H5.20312C4.92698 1.5 4.70312 1.72386 4.70312 2V3C4.70312 3.27614 4.92698 3.5 5.20312 3.5H8.20312C8.47927 3.5 8.70312 3.27614 8.70312 3V2C8.70312 1.72386 8.47927 1.5 8.20312 1.5Z",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70312 2.5H9.70312C9.96834 2.5 10.2227 2.60536 10.4102 2.79289C10.5978 2.98043 10.7031 3.23478 10.7031 3.5V10.5C10.7031 10.7652 10.5978 11.0196 10.4102 11.2071C10.2227 11.3946 9.96834 11.5 9.70312 11.5H3.70312C3.43791 11.5 3.18355 11.3946 2.99602 11.2071C2.80848 11.0196 2.70313 10.7652 2.70312 10.5V3.5C2.70312 3.23478 2.80848 2.98043 2.99602 2.79289C3.18355 2.60536 3.43791 2.5 3.70312 2.5H4.70312",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45312 6H4.95312",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95312 9H5.45312",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermname);
export default __webpack_public_path__ + "static/media/termname.6d67f404f9cf14fc775c1dd22445f671.svg";
export { ForwardRef as ReactComponent };